// extracted by mini-css-extract-plugin
module.exports = {"status":"TransferStatusPlate_status__1ukn9","icon":"TransferStatusPlate_icon__2nXfA"};